var RailObjectService = function () {
  var railObjects = []
  var railObjectsByRailObjectId = {}
  var railObjectsByComlexId = {}
  var railObjectChildren = []
  var railObjectChildrenByParentId = {}

  var subscribers = []

  return {
    getRailObjects: function () {
      return railObjects
    },

    getRailObjectByRailObjectId: function (railObjectId) {
      // Try to retrieve from railObjectsByRailObjectId array
      let railObject = railObjectsByRailObjectId[railObjectId]
      if (railObject) {
        return railObject
      }

      // If not found, then try railObjectChildren array
      railObject = railObjectChildren.find(child => child.RailObjectId === railObjectId)
      if (railObject) {
        return railObject
      }

      console.warn(`RailObject with ID ${railObjectId} not found in either railObjects or railObjectChildren`)
      return undefined
    },

    getRailObjectsByComplexId: function (complexId) {
      return railObjectsByComlexId[complexId] || []
    },

    setRailObjects: function (_railObjects) {
      railObjectsByRailObjectId = {}
      railObjectsByComlexId = {}

      railObjects = _railObjects
      railObjects.forEach(function (railObject) {
        // Hash by Id
        railObjectsByRailObjectId[railObject.RailObjectId] = railObject

        // Hash by complexId
        if (!railObjectsByComlexId[railObject.ComplexId]) {
          railObjectsByComlexId[railObject.ComplexId] = []
        }
        railObjectsByComlexId[railObject.ComplexId].push(railObject)
      })

      subscribers.forEach((subscriber) => {
        subscriber('setRailObjects', null, railObjects)
      })

      // $rootScope.$broadcast('setRailObjects', railObjects);
    },
    updateRailObject: function (_railObject) {
      var railObject = railObjectsByRailObjectId[_railObject.RailObjectId]
      var oldObject = JSON.parse(JSON.stringify(railObject))

      railObject.MonitorStatusId = _railObject.MonitorStatusId
      railObject.OperationModeId = _railObject.OperationModeId
      railObject.LastMeasurementId = _railObject.LastMeasurementId
      railObject.StatusMeasurementId = _railObject.StatusMeasurementId
      railObject.MeasurementDateTime = _railObject.MeasurementDateTime
      railObject.StatusMeasurementDateTime = _railObject.StatusMeasurementDateTime

      subscribers.forEach((subscriber) => {
        subscriber('updateRailObject', oldObject, railObjects)
      })
    },
    updateRailObjectProperty: function (_railObject, property) {
      var railObject = railObjectsByRailObjectId[_railObject.RailObjectId]
      var oldObject = JSON.parse(JSON.stringify(railObject))

      railObject[property] = _railObject[property]

      subscribers.forEach((subscriber) => {
        subscriber('updateRailObject', oldObject, railObjects)
      })
    },
    getRailObjectChildren: function () {
      return railObjectChildren
    },
    setRailObjectChildren: function (_railObjectChildren) {
      railObjectChildren = _railObjectChildren

      _railObjectChildren.forEach(function (railObject) {
        if (!railObjectChildrenByParentId[railObject.ParentRailObjectId]) {
          railObjectChildrenByParentId[railObject.ParentRailObjectId] = []
        }

        railObjectChildrenByParentId[railObject.ParentRailObjectId].push(railObject)
      })
    },
    getRailObjectChildrenByParentId: function (parentRailObjectId) {
      return railObjectChildrenByParentId[parentRailObjectId]
    },
    subscribe: function (fn) {
      subscribers.push(fn)
    },
    unsubscribe: function (fn) {
      var index = subscribers.indexOf(fn)
      if (index >= 0) {
        subscribers.splice(index, 1)
      } else {
        throw new Error('not found')
      }
    }
  }
}

export default new RailObjectService()



// WEBPACK FOOTER //
// ./src/services/RailObjectService.js